import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CommissionChargeCancelMsg } from "../../../Common/AdviserCharges/Components/CommissionChargeCancelMsg";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { AdviceChargeReview } from "../../../Common/Review/Component/AdviceChargeReview";
import { InvestmentReview } from "../../../Common/Review/Component/InvestmentReview";
import { PaymentsInReview } from "../../../Common/Review/Component/PaymentsInReview";
import { IWizardDataModelTemplate } from "../../Models/WizardDataModelTemplate";
import { FinancialAdviceReview } from "../../../Common/Review/Component/FinancialAdviceReview";
import { BWACheck } from "../../../Common/Review/Component/BWACheck";

interface IReviewProps extends IProcessComponentProps {
    type: SubAccountType;
    data: IWizardDataModelTemplate;
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private isShowInvestmentSelection(data, subAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(subAccountType))
            {return (
                data.PreRetirementInstrumentSelections?.Instruments?.length > 0 ||
                data.PostRetirementInstrumentSelections?.Instruments?.length > 0
            );}
        return data.InstrumentSelections?.Instruments?.length > 0;
    }

    private getReviewProps = (data, subAccountType) => {
        return { data: data, subAccountType: subAccountType, process: ProcessType.SinglePayment, colNum: 3 };
    };

    public render(): JSX.Element {
        const { data, type } = this.props;
        const contribution = data.Contribution;

        return (
            <div>
                <h2>Review</h2>
                <CommissionChargeCancelMsg
                    cancelAll={this.props.data.Contribution.CancelAllCommissionCharges}
                    processType={ProcessType.SinglePayment}
                />
                <BWACheck extraInfo={data} />
                <FinancialAdviceReview {...this.getReviewProps(contribution, type)} />
                <PaymentsInReview isOpen={true} {...this.getReviewProps(contribution, type)} extraInfo={data} />
                {!SubAccountTypeHelper.isCashAccount(type) && (
                    <AdviceChargeReview {...this.getReviewProps(contribution, type)} extraInfo={data} />
                )}
                {this.isShowInvestmentSelection(contribution, type) && (
                    <InvestmentReview
                        {...this.getReviewProps(contribution, type)}
                        extraInfo={data}
                        ownerHierarchyId={HierarchyIdHelper.generateHierarchyId(this.props.data.HierarchyId).entityId}
                    />
                )}
            </div>
        );
    }
}
